import { useAuth0 } from '@auth0/auth0-react'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0()
  const location = useLocation()
  const redirectInitiated = useRef(false)

  useEffect(() => {
    if (isLoading || isAuthenticated || redirectInitiated.current) return
    redirectInitiated.current = true
    loginWithRedirect({
      appState: {
        returnTo: `${location.pathname}${location.search}${location.hash}`,
      },
    })
  }, [isAuthenticated, isLoading, location, loginWithRedirect])

  if (isAuthenticated) {
    return children
  }

  return (
    <div className="protected-loading" role="status" aria-live="polite">
      {isLoading ? 'Checking your membership…' : 'Redirecting you to sign in…'}
    </div>
  )
}

export default ProtectedRoute
